import { Icon, IconProps, forwardRef } from '@chakra-ui/react'
import { BiLinkExternal } from 'react-icons/bi'

export const ExternalIcon = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} {...props} as={BiLinkExternal} />
))
